<script>
/**
 * Widget Component
 */
export default {
  props: {
    statistics: { type: Object },
  },
  data() {
    return {
      statData: [
        {
          title: "Atendimentos",
          icon: "ri-store-2-line",
          value: "R$ 38.452",
          subvalue: " 2.4% "
        },
        {
          title: "Preço médio Consulta",
          icon: "ri-briefcase-4-line",
          value: "R$ 15.40",
          subvalue: " 2.4% "
        }
      ]
    };
  },
  mounted() {
    // Set the initial number of items
    this.statData[0].value = this.statistics.attements.qtde ?? this.statistics.attements.qtde;
    const precoMedio = this.statistics.attements.medio ?? this.statistics.attements.medio;
    this.statData[1].value = 'R$ '+this.formatterFloatBR(precoMedio, 2);
  },
};
</script>

<template>
  <div class="row">
    <div class="col-md-4">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">Pacientes</p>
              <h4 class="mb-0">{{ this.statistics.pacients }}</h4>
            </div>
            <div class="text-primary">
              <i class="ri-stack-line font-size-24"></i>
            </div>
          </div>
        </div>

        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span class="badge badge-soft-success font-size-11">
              <i class="mdi mdi-menu-up"></i>
              0
            </span>
            <span class="text-muted ml-2">Perído anterior</span>
          </div>
        </div>
      </div>
    </div>



    <div class="col-md-4" v-for="(data, index) in statData" :key="index">
      <div class="card">
        <div class="card-body">
          <div class="media">
            <div class="media-body overflow-hidden">
              <p class="text-truncate font-size-14 mb-2">{{data.title}}</p>
              <h4 class="mb-0">{{data.value}}</h4>
            </div>
            <div class="text-primary">
              <i :class="`${data.icon} font-size-24`"></i>
            </div>
          </div>
        </div>

        <div class="card-body border-top py-3">
          <div class="text-truncate">
            <span class="badge badge-soft-success font-size-11">
              <i class="mdi mdi-menu-up"></i>
              {{data.subvalue}}
            </span>
            <span class="text-muted ml-2">Perído anterior</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->
</template>